import { ListItem, ListItemIcon, ListItemText, useTheme } from '@mui/material';

import { PortalTheme } from '@frontend-libs/portal';

interface ListEmptyItemProps {
  icon: React.ReactNode;
  text: string;
}

export const ListEmptyItem = (props: ListEmptyItemProps) => {
  const theme = useTheme<PortalTheme>();

  return (
    <ListItem
      sx={{
        width: '100%',
        borderRadius: `${theme.shape.borderRadius}px`,
        backgroundColor: theme.palette.grey[100],
        minHeight: '53px',
        padding: 0,
        margin: 0,
      }}
    >
      <ListItemIcon sx={{ padding: '16px', paddingRight: '8px' }}>
        {props.icon}
      </ListItemIcon>
      <ListItemText
        sx={{ padding: '16px', paddingLeft: '0', margin: 0 }}
        primary={props.text}
        slotProps={{
          primary: {
            sx: { color: theme.palette.text.secondary },
          },
        }}
      />
    </ListItem>
  );
};
